import React from 'react';
import '../../../../scss/metrics-charts.scss';
import AnalyticsList from "../AnalyticsList";

class MetricsTable extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            displayType: 'table',
        };

        this.changeDisplayType = this.changeDisplayType.bind(this);
    }

    getColumns() {
        return [
            {
                Header: this.props.keyName,
                accessor: 'key'
            },
            {
                Header: this.props.valueName,
                accessor: 'value'
            },
        ];
    }

    changeDisplayType(type) {
        this.setState({displayType: type});
    }

    render() {
        let {metrics} = this.props;

        return (
            <div>
                <AnalyticsList
                    metrics={metrics}
                    columns={this.getColumns()}
                    filterable={false}
                    loadMetrics={this.props.loadMetrics}
                    sortable={false}
                />
            </div>

        );
    }
}

export default MetricsTable;


// WEBPACK FOOTER //
// ./web/src/components/analytics/metrics/MetricsTable.jsx